import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams, useNavigate } from "react-router-dom";
import {
  TextField,
  InputLabel,
  Input,
  Button,
  Autocomplete,
} from "@mui/material";
import { signin } from "actions/userActions";
import LoadingBox from "components/LoadingBox";
import MessageBox from "components/MessageBox";
import styles from "assets/jss/vivoleo-react-kit/views/GenerateReportScreenStyle";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

const useStyles = makeStyles(styles);

export default function SigninScreen(props) {
  const classes = useStyles();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  // const { requrl }= useParams();
  /** The current relative URL (pathname + search + hash). */
  const requrl = () => {
    const loc = props.location;
    return loc.pathname + loc.search + loc.hash;
  };
  const redirect = requrl.search ? requrl.search.split("=")[1] : "/";

  /*
  const redirect = props.location.search
    ? props.location.search.split('=')[1]
    : '/';
*/
  const userSignin = useSelector((state) => state.userSignin);
  const { userInfo, loading, error } = userSignin;

  const dispatch = useDispatch();
  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(signin(email, password));
  };
  useEffect(() => {
    if (userInfo) {
      navigate(redirect, { replace: true });
      //props.history.push(redirect);
    }
  }, [props.history, redirect, userInfo]);
  return (
    <div>
      <div className={classes.space30}> </div>
      <GridContainer justify="center" className={classes.contentText}>
        <GridItem xs={12} sm={8} md={6}>
          <form className="form" onSubmit={submitHandler}>
            <div>
              <h1>Sign In</h1>
            </div>
            <div className={classes.space30}> </div>
            {loading && <LoadingBox></LoadingBox>}
            {error && <MessageBox variant="danger">{error}</MessageBox>}
            <div className={classes.space30}> </div>
            <div>
              <InputLabel htmlFor="email">Email address</InputLabel>
              <Input
                type="email"
                id="email"
                fullWidth={true}
                placeholder="Enter email"
                required
                onChange={(e) => setEmail(e.target.value)}
              ></Input>
            </div>
            <div className={classes.space30}> </div>
            <div>
              <InputLabel htmlFor="password">Password</InputLabel>
              <Input
                type="password"
                id="password"
                fullWidth={true}
                placeholder="Enter password"
                required
                onChange={(e) => setPassword(e.target.value)}
              ></Input>
            </div>
            <div className={classes.space30}> </div>
            <div>
              <label />
              <Button variant="contained" size="medium" type="submit">
                Sign In
              </Button>
            </div>
            <div className={classes.space30}> </div>
            <div>
              <label />
              <div>
                New customer?{" "}
                <Link to={`/register?redirect=${redirect}`}>
                  Create your account
                </Link>
              </div>
            </div>
          </form>
        </GridItem>
      </GridContainer>
    </div>
  );
}
